"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var csrfToken = (_a = document.querySelector('meta[name="eccube-csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content');
// Axiosのインスタンスを作成
var axiosInstance = axios_1.default.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'ECCUBE-CSRF-TOKEN': csrfToken || '',
    },
    withCredentials: true,
});
exports.default = axiosInstance;
